import { URL_ASISTENCIA_INCIDENCIA, URL_BASE, URL_REPORTE_DANOS_PROVEEDOR } from "../../constants/url";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../utils/composeNotification";
import { get, post } from "../../utils/fetch";
import { types } from "../types/types";
import { startLoadAsistencia } from "./detalleActions";
import { notification } from "./notificationActions";

export const startSetIncidencia = (body) => {
  return async (dispatch) => {
    const result = await post(
      `${URL_ASISTENCIA_INCIDENCIA}/SetIncidencia`,
      body
    );
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false))
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
    }
  };
};


export const startSetIncidencia2 = (body) => { 
  // viende de otro lado, no del detalle, no necesitamos bajar la asistencia
  return async (dispatch) => {
    const result = await post(
      `${URL_ASISTENCIA_INCIDENCIA}/SetIncidencia`,
      body
    );
    if (result.code === 0) {
      await dispatch(startGetIncidenciasByAsistenciaID(body.asistenciaID))
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
    }
  };
};




//
export const startGetIncidenciasByAsistenciaID = (asistenciaID) => {
  return async (dispatch) => {
    const result = await get(
      `${URL_ASISTENCIA_INCIDENCIA}/GetIncidenciasByAsistenciaID/${asistenciaID}`
    );
    if (result.code === 0) {
      dispatch(storeIncidencias(result.data));
    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
    }
  };
}

const storeIncidencias = (incidencias) => ({
  type: types.storeIncidencias,
  payload: incidencias,
});

export const startSetEnEsperaUsuario = (asistenciaID) => {
  return async (dispatch, getState) => {

    var url = `${URL_ASISTENCIA_INCIDENCIA}/SetEnEsperaUsuario`;

    const result = await post(url, {asistenciaID});

    if (result.code === 0) {
      dispatch(startLoadAsistencia(asistenciaID))
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
    }
  }}

export const startSetQuejaPotencial = (body) => {
  return async (dispatch) => {
    const result = await post(`${URL_BASE}/api/Cabina/SetQuejaPotencial`, body);

    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID));
      dispatch(notification(composeSuccessNotification(result.data)));
      return true;
    }

    dispatch(notification(composeErrorNotification(`${result.error}`)));
    return false;
  };
};

export const startReporteDano = (body) => {
  return async (dispatch) => {
    const result = await post(
      `${URL_REPORTE_DANOS_PROVEEDOR}/ReporteDano`,
      body
    );
    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
    }
  };
};

export const startSetIncidenciaInterna = (body) => {
  return async (dispatch) => {
    const result = await post(
      `${URL_ASISTENCIA_INCIDENCIA}/SetIncidencia2`,
      body
    );
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
    }
  };
};
